const _getters = {
  teamNameMaxLength: () => {
    return 50
  },
}

export default _getters
